import React, { useEffect, useState } from 'react'

import EmergencyRoomDetailsLayout from 'presentation/hospital/layouts/EmergencyRoom/EmergencyRoomDetails'
import { EmergencyRoomAttendanceModel } from 'domain/entities/emergency-room-attendance.model'
import { useHistory, useLocation } from 'react-router'
import { useServices } from 'presentation/hooks/use-services'
import { emergencyRoomDetailsFields } from './fields'
import { toast } from 'react-toastify'
import {
  WithLoading,
  WithLoadingProps
} from 'presentation/shared/components/HOCs/WithLoading'
import { ReligionModel } from 'domain/entities/religion-model'

function EmergencyRoomDetails({ setIsLoading }: WithLoadingProps) {
  const [emergencyRoom, setEmergencyRoom] =
    useState<EmergencyRoomAttendanceModel>()
  const [religions, setReligions] = useState<ReligionModel[]>([])
  const history = useHistory()
  const { state } = useLocation<{ token?: string }>()
  const emergencyRoomService = useServices().emergencyRoom
  const religionService = useServices().religion

  const loadData = async () => {
    try {
      setIsLoading(true)
      const token = state?.token
      if (!token) return history.push('/home')
      const response = await emergencyRoomService.getEmergencyRoomByToken({
        token,
        fields: emergencyRoomDetailsFields
      })
      setEmergencyRoom(new EmergencyRoomAttendanceModel(response))
      if (religions.length !== 0) return
      const religionResponse = await religionService.loadReligions()
      setReligions(religionResponse)
    } catch (error: any) {
      toast.error(error.message)
    } finally {
      setIsLoading(false)
    }
  }

  useEffect(() => {
    if (emergencyRoom) return
    loadData()
  }, [])

  return (
    <EmergencyRoomDetailsLayout
      emergencyRoom={emergencyRoom}
      refetchEmergencyRoom={loadData}
      religions={religions}
    />
  )
}

export default WithLoading(EmergencyRoomDetails)
